/* eslint-disable @typescript-eslint/no-unsafe-return */

export const isMemphisMarathon = (eventId: number): boolean => {
  const SJMMW_IDS = [32414, 164588];

  return SJMMW_IDS.includes(eventId);
};

const editables = [
  'SHIRT SIZE',
  'QKEY_EMERGENCYNAME',
  'QKEY_TELE_EMERGENCYPHONE',
  'QKEY_Emergency',
  'Emergency_Relationship',
  'QKEY_ALLERGIES',
  'Country_Represented',
  'CORRAL',
  'Times_Participated_SJMMW',
  'Bib_Name',
  // 'Is_Patient_Fam',
  // 'Military_First_Responder',
  // 'alsac_employee',
  // 'PERSONAL_BACKGROUND',
  // 'MOBILE_PHONE',
];

export const getReadOnlyQuestions = (
  allQuestions: any[],
  frId: number
): any[] => {
  if (!isMemphisMarathon(frId)) return [];
  // console.log('All questions', { allQuestions });
  return allQuestions
    .map((q) => q.key)
    .filter((key) => !editables.includes(key));
};
